export const photos = [
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553521305/Duvar/duvarkapak.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553521304/Duvar/duvar004.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553521302/Duvar/duvar002.png'
];